import React from "react";
import { Grid, Button } from "@material-ui/core";
import { Controller, useFieldArray } from "react-hook-form";
import { SectionProps } from "./SectionProps";
import { PublicEnquiryModel } from "../../domain/PublicEnquiry";
import { fieldLabels } from "./fieldLabels";
import { Error } from "../common/Error";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { subjectService } from "../../services";
import { Select } from "@ofqual/portal-components/components/Select";

export const SubjectsSection: React.FC<{
  sectionProps: SectionProps<PublicEnquiryModel>;
}> = ({ sectionProps }) => {
  const { control, disabled, errors, lookupTracker } = sectionProps;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "subject",
    keyName: "id",
  });

  const [subjectLookups] = useLookup(subjectService);

  return (
    <Grid container spacing={3}>
      {fields.map((item, index) => {
        const fieldNames = {
          subject: `subject[${index}].subjectId`,
        };

        const itemErrors = errors.subject?.[index] || {};

        const validationHelper = (myValue: any) => {
          const iHaveAValue = myValue !== undefined && myValue !== null;
          if (iHaveAValue) return true;
          return false;
        };

        return (
          <React.Fragment key={item.id}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name={fieldNames.subject}
                rules={{
                  validate: validationHelper,
                }}
                as={
                  <Select
                    label={fieldLabels.subject}
                    readOnly={disabled}
                    datatest={`subject-field-${index}`}
                    lookupTracker={lookupTracker}
                    required
                  >
                    {subjectLookups}
                  </Select>
                }
              />
              {itemErrors.subjectName && (
                <Error data-test="subject-error">
                  This field is required
                </Error>
              )}
            </Grid>
            <Grid item xs={2}>
              {!disabled ? (
                <Button
                  color="primary"
                  onClick={() => remove(index)}
                  disabled={disabled}
                  data-test="remove-subject"
                >
                  Remove
                </Button>
              ) : null}
            </Grid>
          </React.Fragment>
        );
      })}
      {!disabled ? (
        <Grid item xs={12}>
          <Button
            color="primary"
            onClick={() => append({ subject: null })}
            disabled={disabled}
            data-test="add-subject"
          >
            Add Subject
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};
